import type { LineElement } from '@/components/canvas/document/publicTypes';
import { type BaseElementConfig, createBase } from '../../registry/factoryShared';

export function createLineElement(
  config: BaseElementConfig & {
    start?: LineElement['data']['start'];
    end?: LineElement['data']['end'];
  },
): LineElement {
  return {
    ...createBase('line', config),
    data: {
      start: config.start,
      end: config.end,
    },
  };
}
